import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ToastContainer } from 'react-toastify';
import reportWebVitals from './reportWebVitals';
import { MyProvider } from './context/MyContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import InterceptorInitializer from './component/apiInterceptor/interceptorInitilazior'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId="287244027272-vcqskb3rfegv6kmt1isfilveo8p1fggu.apps.googleusercontent.com">
    <MyProvider>
      <ToastContainer position="top-right" autoClose={1000} />
      <InterceptorInitializer />
      <App />
    </MyProvider>
  </GoogleOAuthProvider>
);

reportWebVitals();
